<mat-toolbar class="navbar-title desktop">
  <div class="container horizontalFlex">
    <span class="space-filler text desktop" matRipple>
      <span class="navbarIcon" (click)="backButton()"> <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils></span>
      <ng-container *ngIf="title !== ''">{{ title }}</ng-container>
      <ng-container *ngIf="title === ''">{{ titleTranslate | t }}</ng-container>
    </span>
  </div>
</mat-toolbar>
